import {
  fetchDeleteUserReplyTemplate,
  type TDeleteUserReplyTemplateResponse,
  type TDeleteUserReplyTemplateRequest,
} from '../../repositories/chats/v1/delete-user-reply-template';

import type { IErrorResponseSchema } from '../../repositories/chats/entities/schemas/ErrorResponseSchema';
import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

export async function deleteUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TDeleteUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TDeleteUserReplyTemplateResponse> =
      await fetchDeleteUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw new Error((response as IErrorResponseSchema)?.message);
    }

    return response;
  } catch (e) {
    logger.error(e, {
      description: 'Ошибка удаления шаблона ответа',
    });

    throw e;
  }
}
